<template>
  <v-card class="max-width">
    <Subheader dense title="File Metadata">
      <v-btn v-if="edit" color="add" small @click="onAddField">
        <v-icon class="mr-1">add</v-icon>
        {{ $t('Button.Add') }}
      </v-btn>
    </Subheader>
    <v-card-text>
      <v-layout row wrap>
        <template v-if="!edit">
          <v-flex xs4>File Type</v-flex>
          <v-flex xs8>{{ schema != null ? schema.Name : 'Generic'}}</v-flex>
        </template>

        <template v-if="edit">
          <v-flex xs12>
            <v-select box label="File Type" :items="schemaOptions" v-model="formSchemaId" @input="emitSchemaSelect">
            </v-select>
          </v-flex>
        </template>
        <v-divider></v-divider>


        <template v-if="!edit">
          <v-flex v-for="(field, index) in formMetadataFields" xs12 :key="field.Id">
            <FieldKeyMatcher :index="index" :field="field" />
          </v-flex>
        </template>
        <v-flex xs12 v-else>
          <v-form ref="rdrFileMetadata">
            <DatasetFileMetadataInputs v-model="formMetadataFields" :schema="schema" hide-add-button ref="metadata-inputs" @input="emitMetadataInput" @validate="validateMetadata($event)"/>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
  import MetadataUtil from '@/components/mixins/MetadataUtil'
  import ReactivityUtil from '@/components/mixins/ReactivityUtil'
  import MetadataInputField from '@/components/Metadata/MetadataInputField'
  import DatasetFileMetadataInputs from './DatasetFileMetadataInputs'

  import FieldKeyMatcher from './MetadataFields/FieldKeyMatcher'

  import {
    createNamespacedHelpers,
  } from 'vuex'
  const rawdatarepository = createNamespacedHelpers('rawdatarepository')

  export default {
    components: {
      MetadataInputField,
      DatasetFileMetadataInputs,
      FieldKeyMatcher,
    },
    mixins: [MetadataUtil, ReactivityUtil],
    props: {
      edit: {
        type: Boolean,
        default: false,
      },
      schemaId: {
        type: Number,
        required: true,
      },
      metadataFields: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        formMetadataFields: [],
        formSchemaId: 0,
      }
    },
    computed: {
      ...rawdatarepository.mapGetters([
        'metadataSchemas',
        'metadataSchemaById',
      ]),
      schema() {
        let schemaList = this.metadataSchemaById(this.schemaId)
        return schemaList.length > 0 ?
          JSON.parse(JSON.stringify(schemaList[0])) :
          null
      },
      schemaOptions() {
        return this.metadataSchemas.data.map(schema => {
          return {
            text: schema.Name,
            value: schema.Id,
          }
        })
      },
      isLoading() {
        return this.metadataSchemas.isLoading
      },
    },
    watch: {
      metadataFields() {
        this.setMetadataFields()
      },
      schemaId() {
        this.setMetadataFields()
      },
    },
    methods: {
      ...rawdatarepository.mapActions(['getMetadataSchemas']),
      setMetadataFields() {
        this.formMetadataFields = JSON.parse(
          JSON.stringify(this.collapseGroupedFields(this.metadataFields))
        )
        this.formSchemaId = this.schemaId
      },
      onAddField() {
        this.$refs['metadata-inputs'].addField()
      },
      fetchMetadataSchemas() {
        let options = {
          successCb: () => null,
          failedCb: err =>
            console.error('failed getting metadata schemas ', err),
          forced: false,
        }
        this.getMetadataSchemas(options)
      },
      emitMetadataInput() {
        let that = this
        this.$nextTick(() => { 
          if(that.$refs.rdrFileMetadata) 
          {
            that.$refs.rdrFileMetadata.validate()
          }
        })   
        let expandedFields = this.expandGroupedFields(
          this.formMetadataFields
        )
        this.$emit('input-field', expandedFields)
      },
      emitSchemaSelect() {
        this.$emit('input-schema', this.formSchemaId)
      },
      validateMetadata(data){
        let {isValidMandatoryMetadataFields, isValidAdditionalMetadataFields} = data
        this.$emit('check-form', isValidMandatoryMetadataFields && isValidAdditionalMetadataFields)
      },
    },
    mounted() {
      this.fetchMetadataSchemas()
      this.setMetadataFields()
    },
  }
</script>

<style lang="stylus" scoped></style>